import { getBaseInfo, getShareBaseInfo, getProductionInfo } from '@/utils/cache'
import {
  getToken,
  getUserInfo
} from '@/utils/auth'

const state = {
  baseInfo: getBaseInfo(),
  productionInfo: getProductionInfo(),
  shareBaseInfo: getShareBaseInfo(),
  weatherDataType: {},
  token: getToken(),
  userInfo: getUserInfo()
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js